module.exports = "<div ng-if=\"vm.loading\" class=\"loading-overlay\">\n  <div class=\"loading-container\">\n    <h1 translate=\"app.status.loading\"></h1>\n    <i class=\"fa fa-spinner rotating\"></i>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ui/loadingOverlay/loadingOverlay.html
// module id = 1655
// module chunks = 0